import { render } from "./PriorKnowledge.vue?vue&type=template&id=16c6a227"
import script from "./PriorKnowledge.vue?vue&type=script&lang=ts"
export * from "./PriorKnowledge.vue?vue&type=script&lang=ts"
script.render = render

export default script